import React from "react";
import styled from "styled-components";
import { useAuth } from "./providers/auth-context";

const StyledChip = styled.div.attrs({})`
    border-radius: 1px;
    color: ${({ theme }) => theme.palette.primary.main};

    font-size: 8px;
    background-color: ${({ theme }) => theme.palette.background.paper};
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: ${({ theme }) => theme.spacing(1)};
    padding-top: ${({ theme }) => theme.spacing(0.5)};
    padding-right: ${({ theme }) => theme.spacing(1)};
    padding-bottom: ${({ theme }) => theme.spacing(0.5)};
`;

const DemoBadge = (props) => {
    const { isLoading, userHasTeamsSubscription, isDemo } = useAuth();

    if (isLoading || isDemo) return null;
    if (userHasTeamsSubscription) return null;

    return <StyledChip {...props}>DEMO</StyledChip>;
};

export default DemoBadge;
